import { baseUrl, customerBaseApi } from "@/react/services/api/api";
import { PBX } from "@/react/routing/constants";
import axios from "axios";
import oktaAuth from "@/okta-auth";

export const pbxApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getPbxes: build.query({
      query: () => ({
        url: "pbxes",
        method: "GET",
      }),
      providesTags: [PBX],
    }),
    createPbxes: build.mutation({
      query: ({ pbxes }) => ({
        url: "pbxes/bulk",
        method: "POST",
        body: pbxes,
      }),
      invalidatesTags: [PBX],
    }),
    deletePbx: build.mutation({
      query: (pbxId) => ({
        url: `pbxes/${pbxId}`,
        method: "DELETE",
      }),
      invalidatesTags: [PBX],
    }),
  }),
});

export const checkPbxNameCollisionApi = async (pbxName) => {
  const token = oktaAuth.getAccessToken();
  const response = await axios.get(
    `${baseUrl}/v1/pbxes/name-check/${pbxName}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const {
  useGetPbxesQuery,
  useCreatePbxesMutation,
  useDeletePbxMutation,
} = pbxApi;
